<template>
  <div id="supplements">
    <Datatable
      v-if="inventory "
      entity="supplement"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :globalActions="[
        {text: 'supplements.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :onRowClick="onRowEdit">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";
  import { mapActions } from "vuex";

  export default {

    name: "supplements",

    components: { Datatable },

    data() {
      return {
        inventory: null
      };
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.supplements";
      this.$store.state.pageIcon = "/icon/menu.svg";
      this.inventory = await this.$store.getters.getContextInventory;
    },

    methods: {
      ...mapActions(["deleteInventoryEntity"]),

      onCreate() {
        this.$router.push(this.$router.buildContext("/supplement/new"));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/supplement/edit", {supplement: row.id}));
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({ entity: 'supplements', inventory: this.inventory.id, id: row.id });
        this.$refs.datatable.query();
      }
    }
  }

</script>

<style lang="scss" scoped>

  .datatable {
    height: 100%;
  }

</style>
